(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgElementActivity', sgElementActivity);

  function sgElementActivity () {

    return {
      templateUrl: 'app-legacy/components/sg-element-activity/sg-element-activity.html',
      restrict: 'E',
      scope: {
        logs: '=',
        dynamicHeight: '='
      },
      controller: 'sgElementActivityCtrl'
    };
  }
})();
